

<ngx-moveable #moveable
              [target]="targets"
              [keepRatio]="false"
              [edge]="false"
              [bounds]="bounds"
              [container]="elRef.nativeElement"

              [snappable]="true"
              [snapDirections]='{"top":true, "right":true, "bottom":true, "left":true, "center": true, "middle": true}'
              [elementSnapDirections]='{"top":true, "right":true, "bottom":true, "left":true, "center": true, "middle": true}'
              [elementGuidelines]="elementGuideLines"
              [snapDigit]='0'
              [snapThreshold]="magicSize"

              [verticalGuidelines]="getGuideliness(guidelines.vertical, zoom)"
              [horizontalGuidelines]="getGuideliness(guidelines.horizontal, zoom)"

              [draggable]="isMoveable"
              [resizable]="isMoveable"
              [rotatable]="isMoveable"

              [scrollable]="true"
              [scrollContainer]="scrollContainer"
              [scrollThreshold]="0"
              [getScrollPosition]="getScrollPosition"

              [throttleDrag]="resolution"
              [throttleRotate]="1"
              [throttleResize]="1"
              [defaultGroupRotate]="0"

              [ables]="[customButtons]"
              [props]="({ editable: true })"

              (scroll)="onScroll($event)"
              (scrollGroup)="onScroll($event)"

              (drag)="onDrag($event)"
              (dragEnd)="onDragEnd($event)"

              (dragGroup)="onDragGroup($event)"
              (dragGroupEnd)="onDragGroupEnd($event)"

              (resize)="onResize($event)"
              (resizeStart)="onResizeStart($event)"
              (resizeEnd)="onResizeEnd($event)"

              (resizeGroup)="onResizeGroup($event)"
              (resizeGroupStart)="onResizeGroupStart($event)"
              (resizeGroupEnd)="onResizeGroupEnd($event)"

              (rotate)="onRotate($event)"
              (rotateEnd)="onRotateEnd($event)"

              (rotateGroup)="onRotateGroup($event)"
              (rotateGroupEnd)="onRotateGroupEnd($event)"
>
</ngx-moveable>

<div id="fontLoader" style="position: absolute; visibility:hidden"></div>
<div id="playContainer" class="app-theme-dark" #component style="position: absolute;width: 100%; height: 100%;">
    <template #playercontainer></template>
</div>
<div name="htmlLayer" style="pointer-events: none"></div>

